import * as React from 'react';

const CodeSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            d="M16.287 8.711l.71-.711 3.292 3.3.711.711-.71.711L17.02 16l-.711-.711 3.27-3.278-3.292-3.3zM7.713 15.29l-.71.711-3.292-3.3L3 11.99l.71-.711L6.98 8l.711.711-3.27 3.278 3.292 3.3zM13.75 2.665l.984.263L9.83 21.223l-.984-.264 4.902-18.294z"
        />
    </svg>
);

CodeSvg.displayName = 'CodeSvg';
export default CodeSvg;
